<script setup lang="ts">
import {ref, onMounted} from 'vue';
import {useApi} from '@/ts/composables/stateful/use-api';
import LoadingError from '@/vue/templates/loading-error.vue';

const api = useApi();
const privacyPolicyHtml = ref<string>('');
const loading = ref(true);
const error = ref<string | null>(null);

async function fetchPrivacyPolicy(): Promise<void> {
  loading.value = true;
  error.value = null;
  try {
    const legalDocs = await api.public.getLegalDocs();
    if (legalDocs?.privacyPolicy?.legalCopyHTML) {
      privacyPolicyHtml.value = legalDocs.privacyPolicy.legalCopyHTML;
    } else {
      error.value = 'Privacy policy not found.';
    }
  } catch (_e) {
    error.value = 'Failed to load privacy policy.';
  } finally {
    loading.value = false;
  }
}

onMounted(() => {
  void fetchPrivacyPolicy();
});
</script>

<template>
  <loading-error 
    id="privacy-policy-page" 
    :loading="loading" 
    :error="error" 
    type="page"
  >
    <div class="privacy-policy-page">
      <div v-safe-html="privacyPolicyHtml" class="privacy-policy-content"/>
    </div>
  </loading-error>
</template>

<style lang="scss" scoped>
.privacy-policy-page {
  max-width: 800px;
  margin: 2rem auto;
  padding: 1rem;
}
.privacy-policy-content {
  white-space: pre-wrap;

  :deep(a) {
    color: var(--Functional-wl-link-active);
    text-decoration: underline;

    &:visited {
      color: var(--Functional-wl-active-link);
    }

    &:hover,
    &:focus-visible {
      text-decoration: none;
    }
  }
}
</style>
